import { GLOBAL_VERSION_CONTEXT } from '@/components/webcomponents/Global/versioncontext'
import { joinUrl, storybookUrl } from './urls.js'

/**
 * Get CDN base URL for asset loading
 * Provides fallback for when runtime config isn't loaded yet
 */
export function getCdnUrl(...paths: string[]): string {
  return joinUrl(GLOBAL_VERSION_CONTEXT.CDN_ROOT, GLOBAL_VERSION_CONTEXT.VERSION, ...paths)
}

/**
 * Get CSS-specific CDN URL
 * Uses CSS_PATH if available, otherwise falls back to CDN_ROOT + VERSION
 */
export function getCssUrl(...paths: string[]): string {
  const cssPath = GLOBAL_VERSION_CONTEXT.CSS_PATH.replace(/[\\/]+$/, '')
  return joinUrl(getCdnUrl(), cssPath, ...paths)
}

/**
 * Get JavaScript-specific CDN URL
 * Uses JS_PATH if available, otherwise falls back to CDN_ROOT + VERSION
 */
export function getJsUrl(...paths: string[]): string {
  return joinUrl(getCdnUrl(), GLOBAL_VERSION_CONTEXT.JS_PATH, ...paths)
}

export function getStorybookUrl(path: string = '', remote: boolean = false): string {
  return storybookUrl(path, {
    environment: GLOBAL_VERSION_CONTEXT.ENVIRONMENT,
    version: GLOBAL_VERSION_CONTEXT.VERSION,
    remote,
  })
}

export function getVersion(): { version: string } {
  return { version: GLOBAL_VERSION_CONTEXT.VERSION }
}

export function getEnvironment(): { environment: string } {
  return { environment: GLOBAL_VERSION_CONTEXT.ENVIRONMENT }
}
